export default "__VITE_ASSET__BZInhy4H__"